export default "__VITE_PUBLIC_ASSET__cc3cff76__"